import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Nav from "./nav_manager";
import Footer from "../admin/footer";
import axios from 'axios';
import { useState, useEffect } from "react";


const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));


export default function Dashboard() {

  const [list, setList] = useState([])
  const [name, setName] = useState("");

  const [selected, setSelected] = useState(null)
  const [agentList, setAgentList] = useState([])

  const [listold, setListold] = useState([])
  const [listoldStatus, setListoldStatus] = useState(false)

  useEffect(() => {
    const a = localStorage.getItem("Manager");
    if (a == null) {
      window.location.replace("/login")
    } else {
      const queryParams = new URLSearchParams(window.location.search)

      const status = queryParams.get("status")
      setName(queryParams.get("name"))




      getInq(JSON.parse(a)[0].team, status);


      TeamList("Agent", JSON.parse(a)[0].team)

    }




  }, []);

  function getRemainingDays(targetDate) {
    const currentDate = new Date();
    const remainingTime = new Date(targetDate) - currentDate;

    // Convert remaining time from milliseconds to days
    const remainingDays = Math.ceil(remainingTime / (1000 * 60 * 60 * 24));

    return remainingDays;
  }



  const getInq = async (id, status) => {
    const data = new FormData();
    data.append('team_id', id);
    data.append('status', status);

    axios({
      method: 'post',
      url: '/api_lock/manager/all_status_manager.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        setList(Array.isArray(s.data) ? s.data : [])
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };


  const getfilter_Agent = status => {
    const a = list;
    if (listoldStatus) {
      const newArray = a.filter(item => item.agent_name === status);
      setList(newArray)
    } else {
      setListold(a)
      setListoldStatus(true)
      const newArray = a.filter(item => item.agent_name === status);
      setList(newArray)
    }



  }
  const TeamList = async (typ, id) => {
    const data = new FormData();
    data.append('team_id', id);
    data.append('type', typ);
    axios({
      method: 'post',
      url: '/api_lock/manager/team_agent.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        if (typ == "Agent") {

          setAgentList(Array.isArray(s.data) ? s.data : [])
        }
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };
  return (
    <>

      <Nav />
      <div className="page-container" style={{ backgroundColor: "#F9FBFD" }}>
        {/* Content Wrapper START */}
        <div className="main-content">

          <div className="card">
            <div style={{ paddingTop: "10px", paddingLeft: "20px" }}>
              <h4>{name} - Total : {list.length} </h4>

              <br />

              <div className='row' >
                <div className='col-2' style={{ fontSize: '22px', textAlign: 'right', color: "red" }} >
                  <label>Filter by Agent</label>
                </div>
                <div className='col-3' >
                  <Autocomplete
                    disablePortal
                    id="size-small-standard"
                    size="small"
                    value={selected}
                    onChange={(event, newValue) => {
                      setSelected(newValue)
                      if (newValue === null) {

                      } else {

                        getfilter_Agent(newValue.name)

                      }

                    }}
                    options={agentList}
                    // sx={{ width: 100 }}
                    getOptionLabel={(option) => option.name}
                    renderOption={(props, option) => (
                      <Box component="li"  {...props}>{option.name}</Box>
                    )}
                    renderInput={(params) => <TextField {...params} label="Agent Name" />}
                  />
                </div>
                <div className='col-3' >
                  {
                    listoldStatus ? <button style={{ margin: "10px" }} onClick={() => {
                      const a = listold;
                      setList(a)
                      setListoldStatus(false)
                      setSelected()


                    }} className="btn btn-success m-r-5">Reset</button> : ""
                  }
                </div>
              </div>
            </div>

            <div className="card-body">
              <div>
                <div id="data-table_wrapper" className="dataTables_wrapper ">

                  <div className="row">
                    <div className="col-sm-12">
                      <table
                        id="data-table"
                        className="table dataTable"
                        role="grid"
                        aria-describedby="data-table_info"
                      >
                        <thead>
                          <tr role="row">
                            <th className="sorting_asc">
                              ID
                            </th>



                            <th className="sorting">
                              Agent Name
                            </th>
                            <th className="sorting">
                              Response
                            </th>

                            <th className="sorting">
                              Date
                            </th>
                            <th className="sorting">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            list.map((v, i) => (
                              <div key={i}>
                                <tr role="row" className="odd">
                                  <td>{v.inq} </td>
                                  {/* <td>{v.type}</td> */}
                                  <td>{v.agent_name} </td>
                                  <td>{v.response} </td>
                                  <td>{v.date} </td>
                                  <td><a href={"View_inquiry_manager?id=" + v.inq}> <button className="btn btn-warning m-r-5">Info</button></a>
                                  </td>
                                </tr>
                              </div>
                            ))
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>

                </div>
              </div>

            </div>
            <div >





            </div>


          </div>





        </div>
        {/* Content Wrapper END */}
        {/* Footer START */}
        <Footer />
        {/* Footer END */}
      </div>

    </>
  );
}